export default __webpack_public_path__ + "static/media/z_wdt_c_4.227736ff.mp3";